import React from 'react'
import Heading from "./Heading"
import {Link} from 'gatsby'

export default function InfoBlock({heading}) {
    return (
        <section className="bg-theme py-4">
            <div className="container">
        {/*<Heading className="display-4 text-white font-weight-bold" title={heading}/>*/}
                <div className="row">
                    <div className="col-10 col-sm-8 mx-auto text-center">
                        <p className="lead text-white mb-4">
                        Lorem Ipsum is simply dummy text of the 
                        printing and typesetting industry. 
                        Lorem Ipsum has been the industry's 
                        standard dummy text ever since the 1500s,
                        when an unknown printer took a galley 
                        of type and scrambled it to make a type 
                        specimen book. It has survived not only
                        five centuries, but also the leap into
                        electronic typesetting, remaining
                        essentially unchanged. It was popularised
                        in the 1960s with the release of Letraset
                        sheets containing Lorem Ipsum passages, and 
                        more recently with desktop publishing software 
                        like Aldus PageMaker including versions of Lorem Ipsum.
                        </p> 
                        <Link to="/about"/>
                            <button className="btn btn-warning btn-lg">Know More</button>   
                    </div>
                </div>
            </div>
        </section>
    )
}
